import { AppStatus, AppViews, ViewStatus } from 'resources/enums';

export let initialState = {
    app: {
        appStatus: AppStatus.INITIALIZE,
        viewStatus: ViewStatus.VIEW_INIT,
        appView: AppViews.MAIN,        
        appViewData: [],
        webApiHostUrl: null,
        ajaxError: null,        
        answerId: -1,
        showLoader: false,
        userToken: null,
        editorChanges: false,
        showGraphs: true,
        showTitle: true
    }
};